
import { Info } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

const NoDataAlert = () => {
  return (
    <Alert>
      <Info className="h-4 w-4" />
      <AlertTitle>No data available</AlertTitle>
      <AlertDescription>
        You need to add products to view analytics. 
        <a 
          href="/products/add" 
          className="text-blue-500 hover:underline ml-1"
        >
          Add your first product
        </a>
      </AlertDescription>
    </Alert>
  );
};

export default NoDataAlert;
